const matricula_de_aluno_de_atendimento_educacional_especializado = [
  {
    path: "/matricula-de-aluno-de-atendimento-educacional-especializado/:id",
    redirect: "/matricula-de-aluno-de-atendimento-educacional-especializado",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/matricula-de-aluno-de-atendimento-educacional-especializado/:id",
        name: "matricula_de_aluno_de_atendimento_educacional_especializado",
        component: () =>
          import(
            "@/views/MatriculaDeAlunoDeAtendimentoEducacionalEspecializado/MatriculaDeAlunoDeAtendimentoEducacionalEspecializado.vue"
          ),
      },
    ],
  },
];

export { matricula_de_aluno_de_atendimento_educacional_especializado };
